<template>
  <div class="header">
    <div class="container" @mouseleave="handleMouseLeave">
      <div class="logobox">
        <img class="logo" src="../assets/index/logo.png">
      </div>
      <div ref="nav" class="tabbox">
        <div :class="['tab', { active: index === activeNav && moveActiveIndex == index }]" v-for="(item, index) in tabList" :key="index">
          <a :href="`${item.url ? $Path + item.url : 'javascript:void(0);' }`" class="name" @mouseenter="handleMouseEnter(index)" @click="handleTab(index)">{{item.name}}</a>
        </div>
        <div class="underLine" v-if="handleX" :style="{left: handleX + 'px'}"></div>
      </div>
      <div class="login">
        <img class="icon" :src="userInfo && userInfo.headpic ? userInfo.headpic : require('@/assets/index/login-icon.png')" alt="">
        <a v-if="userInfo && userInfo.nick" class="login-font" :href="`${$Path}/#/mine`">{{userInfo.nick.substr(0,10)}}</a>
        <span v-else class="login-font" @click="goLogin">登录</span>
      </div>
      <div class="popup" v-if="showPopup && tabList[moveActiveIndex].popupList" @mouseleave="handlePopupMouseLeave">
        <div class="box">
          <a :href="`${item.url ? $Path + item.url : 'javascript:void(0);' }`" :class="['popupItem', { active : key === activeNav2 && moveActiveIndex2 == key }]" v-for="(item, key) in tabList[moveActiveIndex].popupList" :key="key" @click="handlePopupTab(key, moveActiveIndex)" @mouseenter="handlePopupMouseEnter(key)">{{item.name}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    userInfo: {}
  },
  data() {
    return {
      tabList: [
        {
          name: '首页',
          url: '/#/index'
        },
        {
          name: '小森家族',
          url: '/#/family',
          popupList: [
            {
              name: '实木水漆大板',
              url: '/#/family/kechuang'
            },
            {
              name: '安芯漆面板',
              url: '/#/family/anxin'
            },
            {
              name: '森格板',
              url: '/#/family/senge'
            },
            {
              name: '康芯板',
              url: '/#/family/kangxin'
            },
            {
              name: '晶瓷板',
              url: '/#/family/jingci'
            },
            {
              name: '绿芯胶',
              url: '/#/family/lvxin'
            },
            {
              name: '辅 材',
              url: '/#/family/fucai'
            }
          ]
        },
        {
          name: '小森案例',
          url: '/#/case'
        },
        {
          name: '解决方案',
          url: '/#/solution'
        },
        {
          name: '小森服务',
          url: '/#/serve',
          popupList: [
            {
              name: '设计之家',
              url: '/#/serve/designer'
            },
            {
              name: '家居焕新',
              url: '/#/serve/renew'
            },
            {
              name: '门店查询',
              url: '/#/serve/store'
            },
            {
              name: '查授权家具厂',
              url: '/#/serve/factory'
            },
            {
              name: '防伪查询',
              url: '/#/serve/security'
            },
            {
              name: '资料下载',
              url: '/#/serve/download'
            },
            {
              name: '定制预约',
              url: '/#/serve/cusAppointment'
            },
            {
              name: '常见问题',
              url: '/#/serve/problem'
            }
          ]
        },
        {
          name: '走进小森',
          url: '/#/goin',
          popupList: [
            {
              name: '我是小森',
              url: '/#/goin/im'
            },
            {
              name: '小森新闻',
              url: '/#/goin/news'
            },
            {
              name: '小森荣誉',
              url: '/#/goin/honur'
            },
            // {
            //   name: '合作伙伴',
            //   url: '/#/goin/partners'
            // }
          ]
        },
        {
          name: '加入我们',
          url: '/#/joinus',
          popupList: [
            {
              name: '招聘信息',
              url: '/#/joinus/recruit'
            },
            {
              name: '招商加盟',
              url: '/#/joinus/merchants'
            },
            {
              name: '项目合作',
              url: '/#/joinus/project'
            }
          ]
        }
      ],
      activeNav: null,
      activeNav2: null,
      moveActiveIndex: null,
      moveActiveIndex2: null,
      line_x: null,
      mouse_x: null,
      isMove: false,
      showPopup: false,
    }
  },
  computed: {
    handleX() {
      return this.isMove ? this.mouse_x : this.line_x;
    }
  },
  watch: {
    $route(to, from) {
      this.$nextTick(() => {
        this.tabList.map((item, index) => {
          if (location.href.indexOf(item.url) > 0) {
            if (item.popupList) {
              item.popupList.map((popup, key) => {
                if (location.href.indexOf(popup.url) > 0) {
                  this.activeNav2 = key
                  this.moveActiveIndex2 = key
                }
              })
            }
            this.handleTab(index)
          }
        })
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tabList.map((item, index) => {
        if (location.href.indexOf(item.url) > 0) {
          if (item.popupList) {
            item.popupList.map((popup, key) => {
              if (location.href.indexOf(popup.url) > 0) {
                this.activeNav2 = key
                this.moveActiveIndex2 = key
              }
            })
          }
          this.handleTab(index)
        }
      })
    })
  },
  methods: {
    handleTab(index) {
      if (this.tabList[index].url) {
        this.activeNav = index
        this.moveActiveIndex = index
        this.moveActiveIndex2 = null
        this.line_x = this.handleMouver(index)
      }
    },
    handlePopupTab(index, moveIndex) {
      this.activeNav2 = index
      this.handleTab(moveIndex)
    },
    handleMouseEnter(index) {
      this.moveActiveIndex2 = null
      this.isMove = true;
      this.moveActiveIndex = index;
      this.mouse_x = this.handleMouver(index);
      if (this.tabList[index].popupList) {
        this.tabList[index].popupList.map((popup, key) => {
          if (location.href.indexOf(popup.url) > 0) {
            this.moveActiveIndex2 = key
          }
        })
      } else {
        this.moveActiveIndex2 = null
      }
      this.showPopup = true
    },
    handlePopupMouseEnter(index) {
      this.moveActiveIndex2 = index;
    },
    handleMouseLeave() {
      this.isMove = false;
      this.mouse_x = 0;
      this.moveActiveIndex = this.activeNav;
      this.showPopup = false
    },
    handlePopupMouseLeave() {
      this.moveActiveIndex2 = this.activeNav2
    },
    handleMouver(index) {
      const nav = this.$refs["nav"].children;
      let num = this.$refs["nav"].children[index].clientWidth / 2;
      for (let i = 0; i < nav.length; i++) {
        const item = nav[i];
        if (i + 1 <= index) {
          const itemWidth = item.clientWidth;
          num += itemWidth;
        }
      }
      return num;
    },
    goLogin() {
      this.$emit('needLogin', true)
    }
  }
}
</script>

<style scoped lang="less">
.header {
  width: 100%;
  // background: #4E8B46;
  background: #fff;
  height: 79px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  .container {
    max-width: 1920px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .logobox {
    width: 247px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px 0 0 71px;
    .logo {
      width: 247px;
      height: 48px;
      vertical-align: middle;
    }
  }
  .tabbox {
    // width: 1220px;
    height: 79px;
    font-size: 16px;
    font-weight: 400;
    color: #4E8B46;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    .tab {
      width: 160px;
      position: relative;
      &.active {
        a {
          color: #4E8B46;
        }
      }
      &:hover {
        a {
          color: #4E8B46;
        }
      }
      a {
        text-decoration: none;
        color: #333;
      }
      .name {
        width: 100%;
        height: 79px;
        line-height: 79px;
        display: block;
        cursor: pointer;
      }
    }
    .underLine {
      width: 91px;
      height: 4px; 
      background: #4E8B46;
      position: absolute;
      margin-left: -45.5px;
      bottom: 0px;
      transition: all .2s ease-out;
    }
  }
  .login {
    width: 250px;
    height: 79px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-right: 30px;
    overflow: hidden;
    .icon {
      width: 50px;
      height: 50px;
      margin-right: 6px;
      border-radius: 50%;
      object-fit: cover;
    }
    .login-font {
      width: 100%;
      display: block;
      overflow: hidden;
      font-size: 16px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #333;
      line-height: 26px;
      cursor: pointer;
      -webkit-user-select: none;
      white-space: nowrap;
      text-align: left;
      text-decoration: none;
    }
  }
  .popup {
    width: 100%;
    height: 54px;
    position: absolute;
    top: 79px;
    left: 0;
    transition: all 0.5s linear forwards;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    .box {
      width: 100%;
      height: 54px;
      background: #414141;
      display: flex;
      justify-content: center;
    }
    .popupItem {
      width: 140px;
      height: 100%;
      line-height: 54px;
      padding: 0 5px;
      font-size: 14px;
      color: #FFFFFF;
      cursor: pointer;
      text-decoration: none;
      user-select: none;
      &.active {
        color: #4E8B46;
        position: relative;
        &:after {
          content: '';
          width: 90px;
          height: 4px;
          position: absolute;
          left: 50%;
          margin-left: -45px;
          bottom: 0;
          background: #4E8B46;
        }
      }
      &:hover {
        color: #4E8B46;
        font-weight: 600;
        position: relative;
        &:after {
          content: '';
          width: 90px;
          height: 4px;
          position: absolute;
          left: 50%;
          margin-left: -45px;
          bottom: 0;
          background: #4E8B46;
        }
      }
    }
  }
}
</style>